import API from "$vueCommon/classes/API.js";

export default class CurrencyAPI extends API {

    static data = {};
    static promise = null;

    static info() {
        if (this.promise) {
            return this.promise;
        }

        this.promise = new Promise(resolve => {
            this.get('/api/currency/info').then(response => {
                this.data = response.data;
                resolve(response.data);
            }, reject => {
                reject(data);
            });
        });

        return this.promise;
    }

    get icon() {
        return this.data && this.data.icon ? this.data.icon : null;
    }

    static get symbolPlacement() {
        return this.data && this.data.symbol_placement ? this.data.symbol_placement : null;
    }

    static get symbol() {
        return this.data && this.data.symbol ? this.data.symbol : null;
    }

    static get isoCode() {
        return this.data && this.data.iso_code ? this.data.iso_code : null;
    }
}
